<template>
  <div>
    <p class="page-container">
      登录中...<br />
      <!-- <router-link to="/">点击返回首页 </router-link> -->
    </p>
  </div>
</template>

<style >
.page-container {
  font-size: 25px;
  text-align: center;
  color: rgb(192, 204, 218);
}

.router-link-active {
  font-size: 14px;
}
</style>

<script>
import { ssorequestLogin,getUserByToken,getNavigationBar } from "../api/api";

import router from "@/router";
import { resetRouter, filterAsyncRouter } from "@/router/index";

export default {
  data() {
    return {};
  },
  methods: {
     // 获取用户数据
            getUserInfoByToken(token) {
                var _this = this;
                var loginParams = {token: token};
                getUserByToken(loginParams).then(data => {
 
                    if (!data.success) {
                        _this.$message({
                            message: data.msg,
                            type: 'error'
                        });
                    } else {
                        // _this.closeAlert()
                        // _this.openAlert("接收到用户数据，开始初始化路由树...")
                        _this.loginStr = "接收到用户数据，开始初始化路由树...";
                        // 存储用户角色，用户id
                        // _this.$store.state.roleNames = data.response.RoleNames
                        // _this.$store.state.organization_id = data.response.organization_id
                        localStorage.setItem("organization_id", data.response.organization_id)
                        localStorage.setItem("roleNames", JSON.stringify(data.response.RoleNames))
                        localStorage.setItem("User_Channel", JSON.stringify(data.response.User_Channel))
                        localStorage.setItem("uRealName", JSON.stringify(data.response.uRealName))

                        console.log(data.response)

                        window.localStorage.user = JSON.stringify(data.response)
                        if (data.response.uID > 0) {
                            _this.GetNavigationBar(data.response.uID)
                        }
                    }
                });
            },
            // 获取路由树
            GetNavigationBar(uid) {
                var _this = this;
                var loginParams = {uid: uid, t: new Date()};
                getNavigationBar(loginParams).then(data => {
                    _this.logining = false;
                    if (!data.success) {
                        _this.$message({
                            message: data.msg,
                            type: 'error'
                        });
                    } else {
                        // _this.closeAlert()
                        _this.$message({
                            message: "后台初始化成功",
                            type: 'success'
                        });
                        let userinfo = JSON.parse(window.localStorage.user ? window.localStorage.user : null);
                        _this.$notify({
                            type: "success",
                            message: `登录成功 \n 欢迎管理员：${userinfo.uRealName} ！Token 将在 ${window.localStorage.expires_in / 60} 分钟后过期！`,
                            duration: 6000
                        });


                        window.localStorage.router = (JSON.stringify(data.response.children));

                        let getRouter = data.response.children//后台拿到路由
                        getRouter = filterAsyncRouter(getRouter) //过滤路由
                        router.$addRoutes(getRouter) //动态添加路由

                        _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
                    }
                });
            }
  },
  mounted() {
    var _this = this
    var loginParams = {
      name: this.$route.query.name,
      timestamp: this.$route.query.timestamp,
      signature:this.$route.query.signature
    };
    ssorequestLogin(loginParams).then((data) => {
      if (!data.success) {
        _this.$message({
          message: data.msg,
          type: "error",
        });
        _this.logining = false;
        _this.loginStr = "重新登录";
      } else {
        var token = data.response.token;
        _this.$store.commit("saveToken", token);

        var curTime = new Date();
        var expiredate = new Date(
          curTime.setSeconds(curTime.getSeconds() + data.response.expires_in)
        );
        _this.$store.commit("saveTokenExpire", expiredate);

        window.localStorage.refreshtime = expiredate;
        window.localStorage.expires_in = data.response.expires_in;

        _this.$notify({
          type: "success",
          message: `成功获取令牌，项目初始化中...`,
          duration: 3000,
        });

        _this.loginStr = "成功获取Token，等待服务器返回用户信息...";

        _this.getUserInfoByToken(token);
      }
    });
  },
};
</script>